module.exports = __webpack_public_path__ + "static/img/tu3.73805cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tu3.png
// module id = P+7W
// module chunks = 10